import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=7b4e121d"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4e121d')) {
      api.createRecord('7b4e121d', component.options)
    } else {
      api.reload('7b4e121d', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=7b4e121d", function () {
      api.rerender('7b4e121d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/outgoing-number/dialog-form-wrapper.vue"
export default component.exports